import { useLocalParticipant } from '@livekit/components-react'
import { Button } from '@/components/ui/button'
import { CameraIcon, CameraOffIcon } from './icons'

export function VideoToggle() {
  const { localParticipant } = useLocalParticipant()

  const isCameraEnabled = localParticipant.isCameraEnabled

  const toggleCamera = async () => {
    await localParticipant.setCameraEnabled(!isCameraEnabled)
  }

  return (
    <Button
      variant="outline"
      size="icon"
      onClick={toggleCamera}
      className={
        isCameraEnabled
          ? 'bg-background hover:bg-muted'
          : 'bg-muted text-muted-foreground hover:bg-muted/90'
      }
    >
      {isCameraEnabled ? (
        <CameraIcon className="h-4 w-4" />
      ) : (
        <CameraOffIcon className="h-4 w-4" />
      )}
    </Button>
  )
}
